export const ConnectionPrefix = {
  Lobby: 'Lobby',
  Game: 'Game',
};

export const GameLiveConnectionMethod = {
  Ping: 'Ping',
  DoBet: 'DoBet',
  DoSpin: 'DoSpin',
  CashOut: 'CashOut',
  GameOpen: 'GameOpen',
  BetsClosed: 'BetsClosed',
  ReportState: 'ReportState',
  DoBetResult: 'DoBetResult',
  DoSpinResult: 'DoSpinResult',
  CashOutResult: 'CashOutResult',
  RoundStarted: 'RoundStarted',
  ResultReport: 'ResultReport',
  BalanceUpdate: 'BalanceUpdate',
  RoundFinished: 'RoundFinished',
  AcceptFreebet: 'AcceptFreebet',
  ChangeBombCount: 'ChangeBombCount',
  GetInitialState: 'GetInitialState',
  CheckResultHash: 'CheckResultHash',
  DoBetResultQueue: 'DoBetResultQueue',
  MaintenanceNotify: 'MaintenanceNotify',
  ReportStateResult: 'ReportStateResult',
  UserTournamentInfo: 'UserTournamentInfo',
  CashOutResultQueue: 'CashOutResultQueue',
  GetInitialStateResult: 'GetInitialStateResult',
  ChangeBombCountResult: 'ChangeBombCountResult',
  DoBetResultValidation: 'DoBetResultValidation',
  CheckResultHashResult: 'CheckResultHashResult',
  Reconnecting: 'Reconnect',
  Reconnected: 'Reconnected',
  ConnectionClose: 'ConnectionClose',
  UnderMaintenance: 'UnderMaintenance',
  ChangeWheelType: 'ChangeWheelType',
  ChangeWheelTypeResult: 'ChangeWheelTypeResult',
  ChangePlinkoType: 'ChangePlinkoType',
  ChangeGameType: 'ChangeGameType',
  ChangePlinkoTypeResult: 'ChangePlinkoTypeResult',
  ChangeGameTypeResult: 'ChangeGameTypeResult',
  Error: 'error',
};

export const CommonConnectionsMethod = {
  Reconnecting: 'Reconnect',
  Reconnected: 'Reconnected',
  ConnectionClose: 'ConnectionClose',
  UnderMaintenance: 'UnderMaintenance',
};

export const LiveUpdateConnectionMethod = {
  LiveSpin: 'liveSpin',
  GetSpins: 'GetSpins',
  GetLiveBetsByGame: 'GetLiveBetsByGame',
  LiveBetsByGameResult: 'LiveBetsByGameResult',
  GetHighRollers: 'GetHighrollers',
  SpinsResult: 'SpinsResult',
  HighrollerResult: 'HighrollerResult',
  Highroller: 'Highroller',
  CheckResultHash: 'CheckResultHash',
  CheckResultHashResult: 'CheckResultHashResult',
  ExchangeAmount: 'ExchangeAmount',
  ExchangeAmountResult: 'ExchangeAmountResult',
};
